
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/booking/meeting-room/[roomId]",
      function () {
        return require("private-next-pages/booking/meeting-room/[roomId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/booking/meeting-room/[roomId]"])
      });
    }
  